import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../components/Button";
import { editForward, editRequest, updateUnique, jumpToState } from "../actions/studensts";
import AlertDenger from "../components/AlertDenger";
import AlertSuccess from "../components/AlertSuccess";
import Loading from "../components/Loading";
import Input from "../components/Input";
import { compressAccurately } from "image-conversion";
import { ACT_SUBJECTS, ACT1_SUBJECTS, EXAM_NAMES, GRADE_LEVELS, ScchoolNames } from "../constants/subjects-list";
export default function Edit() {
  const safeValue = (value) => {
    return value === null || value === undefined ? "" : value;
  };
  const user = JSON.parse(localStorage.getItem("profile"));
  const state = useLocation().state;
  const pathname = useLocation().pathname.split("/")[3];
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [collegeCount, setCollegeCount] = useState(() => {
    let count = 1;
    for (let i = 5; i >= 2; i--) {
      if (state?.[`collegeName${i}`]) { count = i; break; }
    }
    return count;
  });
  const [specCount, setSpecCount] = useState(() => {
    let count = 1;
    for (let i = 3; i >= 2; i--) {
      if (state?.[`specialization${i}`]) { count = i; break; }
    }
    return count;
  });


  // For ACT1 Matching Certificate: always use 2 trials
  const matchingTrialCount = 2;
  const superScoreTrialCount = 1;

  function deriveAct2Fields(sourceState) {
    const trials = Array.isArray(sourceState?.act2_trials)
      ? sourceState.act2_trials
          .slice()
          .sort((a, b) => (Number(a?.trial_no) || 0) - (Number(b?.trial_no) || 0))
      : [];

    const getTrial = (trialNo) =>
      trials.find((trial) => Number(trial?.trial_no) === trialNo) || null;

    const trial1 = getTrial(1);
    const trial2 = getTrial(2);
    const trial3 = getTrial(3);

    return {
      act2: Boolean(
        sourceState?.act2_id ||
          trials.length > 0 ||
          sourceState?.act2_score1 ||
          sourceState?.act2_score2 ||
          sourceState?.act2_score3 ||
          sourceState?.subject1 ||
          sourceState?.subject2 ||
          sourceState?.subject3
      ),
      act2_score1: sourceState?.act2_score1 || trial1?.score || "",
      act2_score2: sourceState?.act2_score2 || trial2?.score || "",
      act2_score3: sourceState?.act2_score3 || trial3?.score || "",
      act2_try_date1: sourceState?.act2_try_date1 || trial1?.try_date || "",
      act2_try_date2: sourceState?.act2_try_date2 || trial2?.try_date || "",
      act2_try_date3: sourceState?.act2_try_date3 || trial3?.try_date || "",
      act2_try1_id: sourceState?.act2_try1_id || trial1?.act_trial_id || "",
      act2_try2_id: sourceState?.act2_try2_id || trial2?.act_trial_id || "",
      act2_try3_id: sourceState?.act2_try3_id || trial3?.act_trial_id || "",
      subject1: sourceState?.subject1 || trial1?.subject || "",
      subject2: sourceState?.subject2 || trial2?.subject || "",
      subject3: sourceState?.subject3 || trial3?.subject || "",
      act2_copy_number: sourceState?.act2_copy_number || "",
    };
  }

  // Helper to group flat act1_scores array into trials with subjects
  function groupAct1Scores(flatScores) {
    console.log('Processing act1_scores:', flatScores);

    if (!Array.isArray(flatScores) || flatScores.length === 0) {
      console.log('No scores to process');
      return [];
    }

    // Define the correct subject order
    const SUBJECT_ORDER = ['English', 'Reading', 'Math', 'Science'];

    // Group scores by trial_no
    const groupedByTrial = new Map();

    flatScores.forEach(score => {
      console.log('Processing score:', score);

      const trialNo = Number(score.trial_no) || 1;
      if (!groupedByTrial.has(trialNo)) {
        groupedByTrial.set(trialNo, {
          trial_no: trialNo,
          trial_id: score.trial_id || "",
          trial_date: score.trial_date || "",
          total_score: score.total_score || "",
          exam_row_id: score.exam_row_id || null,
          subjects: []
        });
      }

      const trial = groupedByTrial.get(trialNo);

      // Add subject if it has a name
      if (score.subject_name) {
        const existingSubject = trial.subjects.find(
          s => s.subject_name === score.subject_name
        );

        if (!existingSubject) {
          trial.subjects.push({
            subject_name: score.subject_name,
            subject_score: score.subject_score || "",
            subject_date: score.subject_date || "",
            trial_date: score.trial_date || "",
            exam_row_id: score.exam_row_id || null
          });
        }
      }
    });

    // Sort subjects within each trial by the correct order
    groupedByTrial.forEach((trial) => {
      trial.subjects.sort((a, b) => {
        const orderA = SUBJECT_ORDER.indexOf(a.subject_name);
        const orderB = SUBJECT_ORDER.indexOf(b.subject_name);
        // If subject not found in order array, put it at the end
        return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
      });
    });

    // Convert to array and sort by trial_no
    const sortedTrials = Array.from(groupedByTrial.values())
      .sort((a, b) => a.trial_no - b.trial_no);

    // Ensure each trial has at least 4 subjects
    const processedTrials = sortedTrials.map(trial => ({
      ...trial,
      subjects: trial.subjects.length >= 4 ? trial.subjects :
        [
          ...trial.subjects,
          ...Array(4 - trial.subjects.length).fill(0).map(() => ({
            subject_name: "",
            subject_score: "",
            subject_date: "",
            trial_date: trial.trial_date || "",
            exam_row_id: trial.exam_row_id
          }))
        ]
    }));

    console.log('Processed trials:', processedTrials);
    return processedTrials;
  }

  // Initialize scores with proper structure and preserve existing data
  let initialScores;
  const initialAct2Fields = deriveAct2Fields(state);
  console.log('Initializing scores with state:', {
    act1_scores: state?.act1_scores,
    exam_name: state?.exam_name,
    exam_row_id: state?.act1_exam_row_id,
    act1_trydate1: state?.act1_try_date1,
    // Debug: Check if backend is sending the trial date fields
    act1_try_date1: state?.act1_try_date1,
    act1_try_date2: state?.act1_try_date2,
    act1_try_date3: state?.act1_try_date3,
    act1_try_date4: state?.act1_try_date4,
    act1_try_date5: state?.act1_try_date5,

    act1_try1_id: state?.act1_try1_id,
    act1_try2_id: state?.act1_try2_id,
    act1_try3_id: state?.act1_try3_id,
    act1_try4_id: state?.act1_try4_id,
    act1_try5_id: state?.act1_try5_id,
    backend_state: state // Log the entire state object to see what's coming from backend
  });

  // Function to create empty trial structure
  const createEmptyTrial = (trialNo, examRowId) => ({
    trial_no: trialNo,
    trial_id: "",
    trial_date: "",
    total_score: "",
    exam_row_id: examRowId,
    subjects: Array.from({ length: 4 }, () => ({
      subject_name: "",
      subject_score: "",
      subject_date: "",
      trial_date: "",
      exam_row_id: examRowId
    }))
  });

  if (state?.act1_scores?.length > 0) {
    console.log('Processing act1_scores for initialization');
    const processedScores = groupAct1Scores(state.act1_scores);

    if (state?.exam_name === "ACT1 Matching Certificate") {
      initialScores = processedScores.slice(0, 2);
      while (initialScores.length < 2) {
        initialScores.push(createEmptyTrial(initialScores.length + 1, state.act1_exam_row_id));
      }
    } else if (state?.exam_name === "ACT1 Super Score Certificate") {
      initialScores = [processedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
      // Remove the problematic code that was overriding subject_date with trial_date
      // The subject_date should remain as retrieved from the database
    } else {
      // One Trial Certificate
      initialScores = [processedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
    }
  } else {
    console.log('Creating empty score structure');
    const trialCount = state?.exam_name === "ACT1 Matching Certificate" ? 2 : 1;
    initialScores = Array.from({ length: trialCount }, (_, i) =>
      createEmptyTrial(i + 1, state?.act1_exam_row_id)
    );
  }

  console.log('Initialized scores:', initialScores);

  const [studentData, setStudentData] = useState({
    university: "",
    ...state,
    citizenship: state?.citizenship || "egyptian",
    category: "outside",
    ...initialAct2Fields,
    old_passport: state?.passport_number || "",
    edited_user: user.value[0].username,
    request_edit_user: user.value[0].username,
    image_letter: "",
    image_id: "",
    scores: initialScores,
    // Ensure these fields are initialized
    date_of_birth: state?.date_of_birth || "",

    // Explicitly initialize ACT1 trial dates and IDs from backend
    act1_try_date1: state?.act1_try_date1 || "",
    act1_try_date2: state?.act1_try_date2 || "",
    act1_try_date3: state?.act1_try_date3 || "",
    act1_try_date4: state?.act1_try_date4 || "",
    act1_try_date5: state?.act1_try_date5 || "",
    act1_try1_id: state?.act1_try1_id || "",
    act1_try2_id: state?.act1_try2_id || "",
    act1_try3_id: state?.act1_try3_id || "",
    act1_try4_id: state?.act1_try4_id || "",
    act1_try5_id: state?.act1_try5_id || "",
    act1_score1: state?.act1_score1 || "",
    act1_score2: state?.act1_score2 || "",
    act1_score3: state?.act1_score3 || "",
  });
  console.log({ 'Passport': state?.passport_number, 'DOB': state?.date_of_birth });

  // Sync scores from state if they change (e.g., loaded async)
  // Sync scores from state if they change
  useEffect(() => {
    // console.log('Score sync effect triggered', {
    //   act1_scores: state?.act1_scores,
    //   exam_name: state?.exam_name,
    //   exam_row_id: state?.act1_exam_row_id
    // });

    const createEmptyTrial = (trialNo, examRowId) => ({
      trial_no: trialNo,
      trial_id: "",
      trial_date: "",
      total_score: "",
      exam_row_id: examRowId,
      subjects: Array.from({ length: 4 }, () => ({
        subject_name: "",
        subject_score: "",
        subject_date: "",
        trial_date: "",
        exam_row_id: examRowId
      }))
    });

    if (Array.isArray(state?.act1_scores)) {
      console.log('Processing act1_scores for state update');
      const groupedScores = groupAct1Scores(state.act1_scores);

      let processedScores;
      switch (state?.exam_name) {
        case "ACT1 Matching Certificate":
          processedScores = groupedScores.slice(0, 2);
          while (processedScores.length < 2) {
            processedScores.push(createEmptyTrial(processedScores.length + 1, state.act1_exam_row_id));
          }
          break;

        case "ACT1 Super Score Certificate":
          processedScores = [groupedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
          // Don't override subject_date with trial_date - preserve the database values
          break;

        default: // One Trial Certificate
          processedScores = [groupedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
          break;
      }

      console.log('Setting processed scores:', processedScores);
      setStudentData(prev => ({
        ...prev,
        scores: processedScores
      }));
    }
  }, [state?.act1_scores, state?.exam_name, state?.act1_exam_row_id]);

  useEffect(() => {
    const nextAct2Fields = deriveAct2Fields(state);

    setStudentData((prev) => ({
      ...prev,
      ...nextAct2Fields,
    }));
  }, [state?.act2_id, state?.act2_trials, state?.act2_score1, state?.act2_score2, state?.act2_score3, state?.subject1, state?.subject2, state?.subject3]);

  // Handle exam name changes with proper trial count initialization
  useEffect(() => {
    // Skip if no exam name selected
    if (!studentData.exam_name) {
      return;
    }

    // Process existing act1_scores if available
    if (state?.act1_scores?.length > 0 && studentData.exam_name !== state?.exam_name) {
      const processedScores = groupAct1Scores(state.act1_scores);
      let newScores = [];

      switch (studentData.exam_name) {
        case "ACT1 Matching Certificate":
          // Take up to 2 trials for matching certificate
          newScores = processedScores.slice(0, 2);
          while (newScores.length < 2) {
            newScores.push({
              trial_no: newScores.length + 1,
              trial_id: "",
              trial_date: "",
              total_score: "",
              subjects: Array.from({ length: 4 }, () => ({
                subject_name: "",
                subject_score: "",
                subject_date: "",
                trial_date: ""
              }))
            });
          }
          break;

        case "ACT1 Super Score Certificate":
          // Take the latest trial for super score
          newScores = processedScores.slice(0, 1);
          // Don't override subject_date with trial_date - preserve the database values
          break;

        case "ACT1 One Trial Certificate":
          // Take just one trial
          newScores = processedScores.slice(0, 1);
          break;

        default:
          newScores = processedScores.slice(0, 1);
      }

      // Update state with processed scores
      setStudentData(prev => ({
        ...prev,
        scores: newScores
      }));
      return;
    }

    // If no act1_scores or same exam name, just initialize with empty trials
    if (studentData.exam_name === state?.exam_name) {
      return;
    }

    // Determine number of trials based on exam type
    const trialCount = studentData.exam_name === "ACT1 Matching Certificate"
      ? matchingTrialCount
      : superScoreTrialCount;

    // Create empty trials with the determined count
    const emptyTrials = Array.from({ length: trialCount }, (_, i) => ({
      trial_no: i + 1,
      trial_id: "",
      trial_date: "",
      total_score: "",
      subjects: Array.from({ length: 4 }, () => ({
        subject_name: "",
        subject_score: "",
        subject_date: "",
        trial_date: ""
      }))
    }));

    // Update state with empty trials
    setStudentData(prev => ({
      ...prev,
      scores: emptyTrials
    }));

  }, [studentData.exam_name, state?.exam_name, matchingTrialCount, superScoreTrialCount, state?.act1_scores]);
  const pathname_two = useLocation().pathname.split("/")[3];

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading(false);
      if (pathname === "new") {
        // navigate("/main/invoice/new");
      } else if (pathname === "request_edit") {
        // navigate("/main/auditing/request_edit");
      }
    }, 3000);
  }

  // Update trial-level fields (total_score, trial_date, trial_id)
  const handleTrialChange = (trialIndex, field, value) => {
    setStudentData((prev) => {
      const updatedScores = [...(prev.scores || [])];
      updatedScores[trialIndex] = {
        ...updatedScores[trialIndex],
        [field]: field === 'total_score'
          ? (value === '' ? '' : parseInt(value) || updatedScores[trialIndex].total_score || '')
          : value,
      };

      console.log(`Updated ${field} for trial ${trialIndex + 1}:`, {
        field: field,
        value: value,
        trialIndex: trialIndex,
        updatedTrial: updatedScores[trialIndex]
      });

      return { ...prev, scores: updatedScores };
    });
  };

  const handleSubjectChange = (trialIndex, subjectIndex, field, value) => {
    setStudentData(prev => {
      const updatedScores = [...prev.scores];
      const trial = updatedScores[trialIndex];
      const updatedSubjects = [...trial.subjects];
      let newSubject = { ...updatedSubjects[subjectIndex], [field]: value };

      // Always sync trial_date for ACT1 One Trial Certificate
      if (prev.exam_name === "ACT1 One Trial Certificate") {
        newSubject.trial_date = trial.trial_date;
      }

      // For subject_date field, ensure it's properly set
      if (field === 'subject_date') {
        newSubject.subject_date = value;
        console.log('Setting subject_date:', value);
      }

      updatedSubjects[subjectIndex] = newSubject;
      updatedScores[trialIndex] = {
        ...trial,
        subjects: updatedSubjects
      };

      console.log('Updated subject:', newSubject);
      return { ...prev, scores: updatedScores };
    });
  };
  // Add a new subject to a trial
  const handleAddSubject = (trialIndex) => {
    setStudentData((prev) => {
      const updatedScores = [...(prev.scores || [])].map((trial, index) => {
        if (index !== trialIndex) return trial;

        const newSubject = {
          subject_name: "",
          subject_score: "",
          subject_date: "",
          trial_date: prev.exam_name === "ACT1 One Trial Certificate" ? trial.trial_date : ""
        };

        return {
          ...trial,
          subjects: [
            ...(trial.subjects || []),
            newSubject
          ]
        };
      });

      return { ...prev, scores: updatedScores };
    });
  };

  // Remove a subject from a trial
  const handleRemoveSubject = (trialIndex, subjectIndex) => {
    setStudentData((prev) => {
      const updatedScores = [...(prev.scores || [])].map((trial, tIndex) => {
        if (tIndex !== trialIndex) return trial;

        return {
          ...trial,
          subjects: (trial.subjects || []).filter((_, sIndex) => sIndex !== subjectIndex)
        };
      });

      return { ...prev, scores: updatedScores };
    });
  };

  // Default structure for trials with dynamic subjects count
  const initializeDefaultTrials = (maxSubjects = 4) => {
    return Array.from({ length: 3 }, (_, trialIndex) => ({
      trial_no: trialIndex + 1,
      total_score: "",
      trial_date: "",
      trial_id: "",
      subjects: Array.from({ length: maxSubjects }, () => ({
        subject_name: "",
        subject_score: "",
        subject_date: "",
        trial_date: "",
      })),
    }));
  };

  const DEFAULT_TRIALS = initializeDefaultTrials();

  // Always render scores safely (fallback to default structure)
  // If we have scores with subjects, use their maximum subject count
  const maxSubjectsInScores = studentData.scores?.reduce((max, trial) =>
    Math.max(max, trial.subjects?.length || 0), 0) || 4;

  const scoresToRender = studentData.scores?.length
    ? studentData.scores
    : initializeDefaultTrials(Math.max(4, maxSubjectsInScores));


  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('Original studentData scores:', studentData.scores);
      console.log('SSC Trial Data:', {
        act1: studentData.act1,
        act1_score1: studentData.act1_score1,
        act1_try_date1: studentData.act1_try_date1,
        act1_try1_id: studentData.act1_try1_id,
        act1_try_date2: studentData.act1_try_date2,
        act1_try2_id: studentData.act1_try2_id,
        act1_try_date3: studentData.act1_try_date3,
        act1_try3_id: studentData.act1_try3_id,
        act1_try_date4: studentData.act1_try_date4,
        act1_try4_id: studentData.act1_try4_id,
        act1_try_date5: studentData.act1_try_date5,
        act1_try5_id: studentData.act1_try5_id
      });

      // Prepare the normalized data ensuring SSC trial data is included
      const normalizedData = {
        ...studentData,
        category: "outside",
        // Ensure SSC trial data is explicitly included
        act1: studentData.act1 || false,
        act1_score1: studentData.act1_score1 || "",
        act1_try_date1: studentData.act1_try_date1 || "",
        act1_try1_id: studentData.act1_try1_id || "",
        act1_try_date2: studentData.act1_try_date2 || "",
        act1_try2_id: studentData.act1_try2_id || "",
        act1_try_date3: studentData.act1_try_date3 || "",
        act1_try3_id: studentData.act1_try3_id || "",
        act1_try_date4: studentData.act1_try_date4 || "",
        act1_try4_id: studentData.act1_try4_id || "",
        act1_try_date5: studentData.act1_try_date5 || "",
        act1_try5_id: studentData.act1_try5_id || "",
        scores: studentData.scores?.map(trial => {
          console.log('Processing trial:', trial);
          return {
            ...trial,
            subjects: trial.subjects?.map(subj => {
              console.log('Processing subject:', subj);
              return {
                ...subj,
                subject_date: subj.subject_date || "",  // Ensure subject_date is included
                trial_date: subj.trial_date || trial.trial_date || "" // Ensure trial_date is included
              };
            }).filter(subj =>
              subj.subject_name || subj.subject_score || subj.subject_date || subj.trial_date
            )
          };
        }).filter(trial =>
          trial.trial_id || trial.trial_date || trial.total_score ||
          (trial.subjects && trial.subjects.length > 0)
        )
      };

      // console.log('Normalized data being sent:', normalizedData);
      // console.log('SSC Trial data in normalized:', {
      //   act1: normalizedData.act1,
      //   act1_score1: normalizedData.act1_score1,
      //   act1_try_date1: normalizedData.act1_try_date1,
      //   act1_try1_id: normalizedData.act1_try1_id,
      //   act1_try_date2: normalizedData.act1_try_date2,
      //   act1_try2_id: normalizedData.act1_try2_id,
      //   act1_try_date3: normalizedData.act1_try_date3,
      //   act1_try3_id: normalizedData.act1_try3_id,
      //   act1_try_date4: normalizedData.act1_try_date4,
      //   act1_try4_id: normalizedData.act1_try4_id,
      //   act1_try_date5: normalizedData.act1_try_date5,
      //   act1_try5_id: normalizedData.act1_try5_id
      // });

      let res;
      if (pathname === "new") {
        // Save the student first
        console.log('About to call editForward with data:', normalizedData);
        res = await editForward(normalizedData);
        await updateUnique(normalizedData.old_passport);
      } else if (pathname === "request_edit") {
        console.log('About to call editRequest with data:', normalizedData);
        res = await editRequest(normalizedData);
      }


      // Handle response
      if (res.status === 200) {
        setShowSuccessAlert(true);
        setText(res.data.message);
      } else {
        setShowDengerAlert(true);
        setText(res.data.ERROR || "An error occurred while saving");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setShowDengerAlert(true);
      setText(error.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };



  const handleInputChange = async (e) => {
    const target = e.target;
    let value;
    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "file") {
      const file = target.files[0];
      const compressedImage = await compressAccurately(file, 100);
      value = await convertToBase64(compressedImage);
    } else {
      value = target.value;
    }

    const name = target.name;
    const newStudentData = { ...studentData, [name]: value };

    // Debug logging for SSC trial fields
    if (name.startsWith('act1_try_date') || name.startsWith('act1_try') && name.endsWith('_id') || name === 'act1_score1' || name === 'act1') {
      console.log('SSC Trial field updated:', {
        fieldName: name,
        newValue: value,
        currentData: {
          act1: newStudentData.act1,
          act1_score1: newStudentData.act1_score1,
          act1_try_date1: newStudentData.act1_try_date1,
          act1_try1_id: newStudentData.act1_try1_id,
          act1_try_date2: newStudentData.act1_try_date2,
          act1_try2_id: newStudentData.act1_try2_id,
          act1_try_date3: newStudentData.act1_try_date3,
          act1_try3_id: newStudentData.act1_try3_id,
          act1_try_date4: newStudentData.act1_try_date4,
          act1_try4_id: newStudentData.act1_try4_id,
          act1_try_date5: newStudentData.act1_try_date5,
          act1_try5_id: newStudentData.act1_try5_id
        }
      });
    }

    setStudentData(newStudentData);
  };

  const handleSchoolsChange = (e) => {
    const { name, value } = e.target;

    setStudentData((prev) => {
      if (name === 'school_name') {
        // Find the record(s) for this school name
        const matches = ScchoolNames.filter(s => s.scvalue === value);
        // If there are multiple campuses with same name, prefer one that matches current city
        let rec = matches[0] || null;
        if (prev.school_city && matches.length > 1) {
          const byCity = matches.find(s => s.scivalue === prev.school_city);
          if (byCity) rec = byCity;
        }

        return {
          ...prev,
          school_name: value,
          school_city: rec?.scivalue || '',
          school_country: rec?.scountryvalue || '',
        };
      }

      if (name === 'school_city') {
        // If city changes, try to align country using school+city match or any by city
        const rec =
          ScchoolNames.find(s => s.scvalue === prev.school_name && s.scivalue === value) ||
          ScchoolNames.find(s => s.scivalue === value);

        return {
          ...prev,
          school_city: value,
          school_country: rec?.scountryvalue || prev.school_country || '',
        };
      }

      if (name === 'school_country') {
        return { ...prev, school_country: value };
      }

      return { ...prev, [name]: value };
    });
  };

  return (
    <div className="min-h-screen px-4 sm:px-8 py-6 flex justify-center">
      <div
        className="lg:w-4/5 md:w-3/4 w-full min-h-screen rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm shadow-2xl flex flex-col p-3"
      >
        {showSuccessAlert && <AlertSuccess text={text} />}
        {showDengerAlert && <AlertDenger text={text} />}
        <form onSubmit={handleClick} action="submit" className="m-3 rounded-2xl border border-white/10 bg-white/5 p-4 shadow">
          <div className="p-1 ">
            <Input
              type="text"
              placeholder="Full Name"
              name="full_name"
              onChange={handleInputChange}
              value={safeValue(studentData.full_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="First Name"
              name="first_name"
              onChange={handleInputChange}
              value={safeValue(studentData.first_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="Middle 1 Name"
              name="middle1_name"
              onChange={handleInputChange}
              value={safeValue(studentData.middle1_name)}
              required={false}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="Middle 2 Name"
              name="middle2_name"
              onChange={handleInputChange}
              value={safeValue(studentData.middle2_name)}
              required={false}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="Last Name"
              name="last_name"
              onChange={handleInputChange}
              value={safeValue(studentData.last_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            {pathname_two === "new" ? (
              <Input type="text" placeholder="National ID or Passport Number" name="passport_number" disabled onChange={handleInputChange} value={safeValue(studentData.passport_number)} />
            ) : (
              <Input type="text" placeholder="National ID or Passport Number" name="passport_number" onChange={handleInputChange} value={safeValue(studentData.passport_number)} />
            )}

            <Input type="text" placeholder="ACT ID" name="act1_id" onChange={handleInputChange} value={safeValue(studentData.act1_id)} />
            <Input type="text" placeholder="ACT Subject ID" name="act2_id" onChange={handleInputChange} required={false} value={safeValue(studentData.act2_id)} />
            <Input type="text" placeholder="Email" name="email" onChange={handleInputChange} value={safeValue(studentData.email)} />
            <Input type="text" placeholder="Phone" name="phone" onChange={handleInputChange} value={safeValue(studentData.phone)} />
            <div className="relative">
              <Input
                type="date"
                placeholder="Date of Birth"
                name="date_of_birth"
                onChange={handleInputChange}
                value={safeValue(studentData.date_of_birth)}
                title="Date of birth"
                className=""
              />
            </div>
            <div className="m-2 flex items-center justify-center">
              <label htmlFor="citizenship" className="flex-auto text-slate-300">
                <span className="text-red-400">*</span>
                Citizenship:
              </label>
              <select
                id="citizenship"
                name="citizenship"
                value={safeValue(studentData.citizenship) || "egyptian"}
                onChange={handleInputChange}
                className="border border-white/10 rounded-md px-4 py-2 w-3/4 bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
              >
                <option value="egyptian">Egyptian</option>
                <option value="foreign">Foreign</option>
              </select>
            </div>
            <Input type="text" placeholder="City" name="address" onChange={handleInputChange} value={safeValue(studentData.address)} pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$" title="Please enter english language only" />
            <Input type="text" placeholder="Country" name="postal_code" onChange={handleInputChange} value={safeValue(studentData.postal_code)} />
            <div className="m-2 flex items-center justify-center">
              <label htmlFor="name" className="flex-auto text-slate-300">
                <span className="text-red-400">*</span>
                Gender:
              </label>
              <div className="flex-1 flex items-center justify-between text-slate-200">
                <div className="flex gap-1">
                  <input type="radio" name="gender" value="male" required onChange={handleInputChange} checked={studentData.gender === "male"} />
                  <label htmlFor="male">Male</label>
                </div>
                <div className="flex gap-1">
                  <input type="radio" name="gender" value="female" onChange={handleInputChange} checked={studentData.gender === "female"} />
                  <label htmlFor="female">Female</label>
                </div>
              </div>
            </div>

            <div className="m-2 flex items-center justify-center">
              <label htmlFor="name" className="flex-auto text-slate-300">
                <span className="text-red-400">*</span>
                University:
              </label>
              <div className="flex-1 flex items-center justify-between text-slate-200">
                <div className="flex gap-1">
                  <input
                    type="radio"
                    name="university"
                    value="governmental"
                    required
                    onChange={handleInputChange}
                    checked={studentData.university === "governmental"}
                  />
                  <label htmlFor="governmental">Governmental</label>
                </div>
                <div className="flex gap-1">
                  <input
                    type="radio"
                    name="university"
                    value="private"
                    onChange={handleInputChange}
                    checked={studentData.university === "private"}
                  />
                  <label htmlFor="both">Private</label>
                </div>
                <div className="flex gap-1">
                  <input
                    type="radio"
                    name="university"
                    value="both"
                    onChange={handleInputChange}
                    checked={studentData.university === "both"}
                  />
                  <label htmlFor="both">Both</label>
                </div>
              </div>
            </div>
            <div className="m-2 rounded-2xl border border-white/10 bg-white/5 p-3">
              <div className="flex items-center justify-between mb-1">
                <label className="font-medium text-sm text-slate-200">Universities</label>
                {collegeCount < 5 && (
                  <button type="button" onClick={() => setCollegeCount(c => Math.min(c + 1, 5))}
                    className="flex items-center gap-1 text-xs text-indigo-300 hover:text-white border border-indigo-500/30 rounded px-2 py-0.5 bg-indigo-600/10 hover:bg-indigo-600/20">
                    + Add University
                  </button>
                )}
              </div>
              {Array.from({ length: collegeCount }, (_, i) => i + 1).map(num => (
                <div key={num} className="flex items-center gap-1 mb-1">
                  <div className="flex-1 flex items-center justify-between p-2 border border-white/10 rounded-xl bg-white/5">
                    <label htmlFor={`collegeName${num}`} className="flex-auto text-sm text-slate-300">
                      {num === 1 && <span className="text-red-400">*</span>} University {num}:
                    </label>
                    <input type="text" name={`collegeName${num}`} value={safeValue(studentData[`collegeName${num}`])}
                      onChange={handleInputChange} placeholder="College Name" required={num === 1}
                      className="border border-white/10 rounded-xl px-3 py-2 text-sm w-1/2 bg-slate-900 text-white placeholder-slate-500" />
                  </div>
                </div>
              ))}
            </div>
            <div className="m-2 rounded-2xl border border-white/10 bg-white/5 p-3">
              <div className="flex items-center justify-between mb-1">
                <label className="font-medium text-sm text-slate-200">Specializations</label>
                {specCount < 3 && (
                  <button type="button" onClick={() => setSpecCount(c => Math.min(c + 1, 3))}
                    className="flex items-center gap-1 text-xs text-indigo-300 hover:text-white border border-indigo-500/30 rounded px-2 py-0.5 bg-indigo-600/10 hover:bg-indigo-600/20">
                    + Add Specialization
                  </button>
                )}
              </div>
              {Array.from({ length: specCount }, (_, i) => i + 1).map(num => (
                <div key={num} className="flex-1 flex items-center justify-between p-2 m-1 border border-white/10 rounded-xl bg-white/5">
                  <label htmlFor={`specialization${num}`} className="flex-auto text-sm text-slate-300">
                    {num === 1 && <span className="text-red-400">*</span>} Specialization {num}:
                  </label>
                  <input type="text" name={`specialization${num}`} value={safeValue(studentData[`specialization${num}`])}
                    onChange={handleInputChange} placeholder="Enter Specialization" required={num === 1}
                    className="border border-white/10 rounded-xl px-3 py-2 text-sm w-1/2 bg-slate-900 text-white placeholder-slate-500" />
                </div>
              ))}
            </div>
            <div className="flex-1 flex items-center justify-between p-2 m-1 border border-white/10 rounded-xl bg-white/5">
              <label htmlFor="studentyear" className="flex-auto text-slate-300">
                Student Year:
              </label>
              <div className="flex gap-1">
                <input
                  type="text"
                  name="studentyear"
                  value={safeValue(studentData.studentyear)}
                  onChange={handleInputChange}
                  placeholder="Enter Student Year"
                  className="border border-white/10 rounded-xl px-3 py-2 bg-slate-900 text-white placeholder-slate-500"
                />
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between p-2 border m-1 border-white/10 rounded-xl bg-white/5">
              <label htmlFor="schoolNum" className="flex-auto text-slate-300">
                School Num:
              </label>
              <div className="flex gap-1">
                <input
                  type="text"
                  name="schoolNum"
                  value={safeValue(studentData.schoolNum)}
                  onChange={handleInputChange}
                  placeholder="Enter School Number"
                  className="border border-white/10 rounded-xl px-3 py-2 bg-slate-900 text-white placeholder-slate-500"
                />
              </div>
            </div>
            <div className="m-2 flex items-center justify-center"> <label htmlFor="school_name" className="flex-auto text-slate-300"> School Name: </label>
              <input type="text" name="school_name" value={safeValue(studentData.school_name)} onChange={handleInputChange}
                placeholder="Enter School Name" className="border border-white/10 rounded-xl px-4 py-2 w-3/4 bg-slate-900 text-white placeholder-slate-500" />
            </div>
            <div className="m-2 flex items-center justify-center"> <label htmlFor="school_country" className="flex-auto text-slate-300"> School Country: </label>
              <input type="text" name="school_country" value={safeValue(studentData.school_country)} onChange={handleInputChange}
                placeholder="Enter School Country" className="border border-white/10 rounded-xl px-4 py-2 w-3/4 bg-slate-900 text-white placeholder-slate-500" />
            </div>
            <div className="m-2 flex items-center justify-center"> <label htmlFor="school_city" className="flex-auto text-slate-300"> School City: </label>
              <input type="text" name="school_city" value={safeValue(studentData.school_city)} onChange={handleInputChange}
                placeholder="Enter School City" className="border border-white/10 rounded-xl px-4 py-2 w-3/4 bg-slate-900 text-white placeholder-slate-500" />
            </div>

            <Input
              type="text"
              placeholder="School Name"
              name="school_name"
              onChange={handleInputChange}
              value={safeValue(studentData.school_name)}
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="School Country"
              name="school_country"
              onChange={handleInputChange}
              value={safeValue(studentData.school_country)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="School city"
              name="school_city"
              onChange={handleInputChange}
              value={safeValue(studentData.school_city)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <div className="m-2 flex items-center justify-center">
              <label htmlFor="category" className="flex-auto">
                Category:
              </label>
              <input
                readOnly
                disabled
                name="category"
                value="Outside"
                className="border border-white/10 rounded-md px-4 py-2 w-3/4 bg-white/5 text-slate-400 cursor-not-allowed"
              />
            </div>
            <div className="m-2 flex items-center justify-center">
              <label htmlFor="Grade" className="flex-auto">
                Grade Level:
              </label>
              <select
                value={studentData.grade_status}
                name="grade_status"
                onChange={handleInputChange}
                className="border border-white/10 rounded-md px-4 py-2 w-3/4 bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
              >
                <option value="">Select Grade</option>
                {GRADE_LEVELS.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.text}
                  </option>
                ))}
              </select>
            </div>

            <Input
              type="text"
              placeholder="Test Center Name"
              name="test_center_name"
              onChange={handleInputChange}
              required={false}
              value={safeValue(studentData.test_center_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="file"
              onChange={handleInputChange}
              placeholder="Upload Your ID"
              name="image_id"
              required={false}
            />

            <div className="p-4 border border-white/10 rounded-2xl bg-white/5">
              <div className="m-2 flex items-center justify-center">
                <label htmlFor="Exam Name" className="flex-auto">
                  Exam Name:
                </label>
                <select
                  className="flex-initial p-2 ml-1 border border-white/10 rounded-xl bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                  onChange={handleInputChange}
                  name="exam_name"
                  value={safeValue(studentData.exam_name)}
                >
                  <option value=""> No ACT 1</option>
                  {EXAM_NAMES.map((subject, i) => (
                    <option value={subject} key={i}>
                      {subject}
                    </option>
                  ))}
                </select>
              </div>

              {studentData.exam_name === "ACT1 Super Score Certificate" && (
                <>
                  {(studentData.scores && studentData.scores.length > 0 ? studentData.scores : DEFAULT_TRIALS).map((trial, trialIndex) => (
                    <div key={trialIndex} className="flex-initial p-4 ml-1 border border-white/10 rounded-2xl bg-white/5">
                      <div className="font-medium mb-2">Trial {trial.trial_no}</div>
                      <Input
                        type="number"
                        placeholder="Total Score"
                        value={trial.total_score || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "total_score", e.target.value)
                        }
                      />
                      <Input
                        type="date"
                        placeholder={`Trial Date ${trial.trial_no}`}
                        value={trial.trial_date || ""}
                        onChange={(e) => {
                          handleTrialChange(trialIndex, "trial_date", e.target.value);
                          setStudentData(prev => ({ ...prev, act1_try_date1: e.target.value }));
                        }}
                      />
                      <Input
                        type="text"
                        placeholder={`Trial ${trial.trial_no} Id`}
                        value={trial.trial_id || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_id", e.target.value)
                        }
                      />
                      <div className="mt-2">
                        <div className="font-semibold mb-1">
                          Subjects for Trial {trial.trial_no}
                        </div>
                        {(trial.subjects ?? []).map((subject, subjIndex) => (
                          <div key={subjIndex} className="flex gap-2 items-center mb-2">
                            <select
                              value={subject.subject_name || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_name",
                                  e.target.value
                                )
                              }
                              className="p-2 border border-white/10 rounded bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            >
                              <option value="">Select subject</option>
                              {ACT1_SUBJECTS.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.text}
                                </option>
                              ))}
                            </select>
                            <Input
                              type="number"
                              placeholder="Subject score"
                              value={subject.subject_score || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_score",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <Input
                              type="date"
                              placeholder="Subject date"
                              value={subject.subject_date || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_date",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveSubject(trialIndex, subjIndex)}
                              className="px-2 py-1 bg-red-600 hover:bg-red-500 text-white rounded-lg"
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={() => handleAddSubject(trialIndex)}
                          className="mt-2 px-3 py-1 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg"
                        >
                          + Add Subject
                        </button>
                      </div>
                    </div>
                  ))}
                  <Input
                    type="number"
                    placeholder="Number of Copies "
                    name="act1_copy_number"
                    onChange={handleInputChange}
                    value={studentData.act1_copy_number}
                  />
                  <div className="m-2 flex items-center justify-center">
                    <Input
                      type="checkbox"
                      placeholder="SSC Trials"
                      name="act1"
                      required={false}
                      onChange={handleInputChange}
                      value={studentData.act1}
                    />
                  </div>
                  {studentData.act1 && (
                    <>
                      <Input
                        type="date"
                        placeholder="Trial Date 1"
                        name="act1_try_date1"
                        required={false}
                        onChange={handleInputChange}
                        value={studentData.act1_try_date1}
                      />
                      <Input
                        type="text"
                        required={false}
                        placeholder="Trial 1 Id"
                        name="act1_try1_id"
                        onChange={handleInputChange}
                        value={studentData.act1_try1_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 2"
                        required={false}
                        name="act1_try_date2"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date2}
                      />
                      <Input
                        type="text"
                        placeholder="Trial 2 Id"
                        name="act1_try2_id"
                        onChange={handleInputChange}
                        required={false}
                        value={studentData.act1_try2_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 3"
                        required={false}
                        name="act1_try_date3"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date3}
                      />
                      <Input
                        type="text"
                        placeholder="Trial 3 Id"
                        name="act1_try3_id"
                        required={false}
                        onChange={handleInputChange}
                        value={studentData.act1_try3_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 4"
                        required={false}
                        name="act1_try_date4"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date4}
                      />
                      <Input
                        type="text"
                        placeholder="Trial 4 Id"
                        name="act1_try4_id"
                        onChange={handleInputChange}
                        required={false}
                        value={studentData.act1_try4_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 5"
                        required={false}
                        name="act1_try_date5"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date5}
                      />
                      <Input
                        type="text"
                        required={false}
                        placeholder="Trial 5 Id"
                        name="act1_try5_id"
                        onChange={handleInputChange}
                        value={studentData.act1_try5_id}
                      />
                    </>
                  )}
                </>
              )}
              {studentData.exam_name === "ACT1 Matching Certificate" && (
                <>
                  {studentData.scores.slice(0, 2).map((trial, trialIndex) => (
                    <div key={trialIndex} className="p-4 border border-white/10 rounded-2xl bg-white/5 mb-2">
                      <div className="font-medium mb-2">Trial {trial.trial_no}</div>

                      <Input
                        type="number"
                        placeholder="Total Score"
                        value={trial.total_score || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "total_score", e.target.value)
                        }
                      />

                      <Input
                        type="date"
                        placeholder={`Trial Date ${trial.trial_no}`}
                        value={trial.trial_date || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_date", e.target.value)
                        }
                      />

                      <Input
                        type="text"
                        placeholder={`Trial ${trial.trial_no} Id`}
                        value={trial.trial_id || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_id", e.target.value)
                        }
                      />

                      <div className="mt-2">
                        <div className="font-semibold mb-1">
                          Subjects for Trial {trial.trial_no}
                        </div>

                        {(trial.subjects ?? []).map((subject, subjIndex) => (
                          <div key={subjIndex} className="flex gap-2 items-center mb-2">
                            <select
                              value={subject.subject_name || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_name",
                                  e.target.value
                                )
                              }
                              className="p-2 border border-white/10 rounded bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            >
                              <option value="">Select subject</option>
                              {ACT1_SUBJECTS.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.text}
                                </option>
                              ))}
                            </select>

                            <Input
                              type="number"
                              placeholder="Subject score"
                              value={subject.subject_score || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_score",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />

                            <Input
                              type="date"
                              placeholder="Subject date"
                              value={subject.subject_date || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_date",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveSubject(trialIndex, subjIndex)}
                              className="px-2 py-1 bg-red-600 hover:bg-red-500 text-white rounded-lg"
                            >
                              Remove
                            </button>
                          </div>
                        ))}

                        <button
                          type="button"
                          onClick={() => handleAddSubject(trialIndex)}
                          className="mt-2 px-3 py-1 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg"
                        >
                          + Add Subject
                        </button>
                      </div>
                    </div>
                  ))}
                  <Input
                    type="number"
                    placeholder="Number of Copies "
                    name="act1_copy_number"
                    onChange={handleInputChange}
                    value={studentData.act1_copy_number}
                  />
                </>
              )}{" "}
              {studentData.exam_name === "ACT1 One Trial Certificate" && (
                <>
                  {/* Debug Section - Show current trial_id values for One Trial Certificate */}
                  {/* <div className="p-4 mb-4 bg-amber-600/10 border border-amber-500/20 rounded-2xl text-slate-200">
                    <h4 className="font-bold text-sm mb-2 text-amber-300">Debug: One Trial Certificate Trial ID</h4>
                    <div className="text-xs text-slate-300">
                      {scoresToRender.slice(0, 1).map((trial, index) => (
                        <div key={index} className="mb-1">
                          Trial {trial.trial_no}: trial_id = "{trial.trial_id || 'empty'}"
                        </div>
                      ))}
                    </div>
                  </div> */}

                  {scoresToRender.slice(0, 1).map((trial, trialIndex) => (
                    <div key={trialIndex} className="p-4 border border-white/10 rounded-2xl bg-white/5 mb-2">
                      <div className="font-medium mb-2">Trial {trial.trial_no}</div>

                      <Input
                        type="number"
                        placeholder="Total Score"
                        value={trial.total_score || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "total_score", e.target.value)
                        }
                      />

                      <Input
                        type="date"
                        placeholder={`Trial Date ${trial.trial_no}`}
                        value={trial.trial_date || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_date", e.target.value)
                        }
                      />

                      <Input
                        type="text"
                        placeholder={`Trial ${trial.trial_no} Id`}
                        value={trial.trial_id || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_id", e.target.value)
                        }
                      />

                      <div className="mt-2">
                        <div className="font-semibold mb-1">
                          Subjects for Trial {trial.trial_no}
                        </div>

                        {(trial.subjects ?? []).map((subject, subjIndex) => (
                          <div key={subjIndex} className="flex gap-2 items-center mb-2">
                            <select
                              value={subject.subject_name || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_name",
                                  e.target.value
                                )
                              }
                              className="p-2 border border-white/10 rounded bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            >
                              <option value="">Select subject</option>
                              {ACT1_SUBJECTS.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.text}
                                </option>
                              ))}
                            </select>

                            <Input
                              type="number"
                              placeholder="Subject score"
                              value={subject.subject_score || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_score",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />

                            <Input
                              type="date"
                              placeholder="Subject date"
                              value={subject.subject_date || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_date",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveSubject(trialIndex, subjIndex)}
                              className="px-2 py-1 bg-red-600 hover:bg-red-500 text-white rounded-lg"
                            >
                              Remove
                            </button>
                          </div>
                        ))}

                        <button
                          type="button"
                          onClick={() => handleAddSubject(trialIndex)}
                          className="mt-2 px-3 py-1 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg"
                        >
                          + Add Subject
                        </button>
                      </div>
                    </div>
                  ))}
                  <Input
                    type="number"
                    placeholder="Number of Copies "
                    name="act1_copy_number"
                    onChange={handleInputChange}
                    value={studentData.act1_copy_number}
                  />
                </>
              )}
              <div className="p-4 border border-white/10 rounded-2xl bg-white/5">
                <Input
                  type="checkbox"
                  placeholder="ACT Subject"
                  name="act2"
                  required={false}
                  onChange={handleInputChange}
                  value={studentData.act2}
                />
                {studentData.act2 && (
                  <>
                    <Input
                      type="number"
                      placeholder="ACT subject 1 score"
                      name="act2_score1"
                      onChange={handleInputChange}
                      value={studentData.act2_score1}
                    />
                    <div className="m-2 flex items-center justify-center">
                      <label htmlFor="subject1" className="flex-auto">
                        <span className="text-red-600">*</span>
                        Subject 1:
                      </label>
                      <select
                        className="flex-initial p-2 ml-1 border border-white/10 rounded-xl bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                        onChange={handleInputChange}
                        name="subject1"
                        value={studentData.subject1}
                      >
                        {ACT_SUBJECTS.map((subject, i) => (
                          <option value={subject.value} key={i}>
                            {subject.text}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Input
                      type="date"
                      placeholder="Trial Date 1"
                      name="act2_try_date1"
                      onChange={handleInputChange}
                      value={studentData.act2_try_date1}
                    />
                    <Input
                      required={false}
                      type="text"
                      placeholder="Trial 1 Id"
                      name="act2_try1_id"
                      onChange={handleInputChange}
                      value={studentData.act2_try1_id}
                    />
                    <Input
                      type="number"
                      placeholder="ACT subject 2 score"
                      name="act2_score2"
                      required={false}
                      onChange={handleInputChange}
                      value={studentData.act2_score2}
                    />
                    <div className="m-2 flex items-center justify-center">
                      <label htmlFor="subject2" className="flex-auto">
                        ACT subject 2:
                      </label>
                      <select
                        className="flex-initial p-2 ml-1 border border-white/10 rounded-xl bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                        onChange={handleInputChange}
                        name="subject2"
                        value={studentData.subject2}
                      >
                        {ACT_SUBJECTS.map((subject, i) => (
                          <option value={subject.value} key={i}>
                            {subject.text}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Input
                      type="date"
                      required={false}
                      placeholder="Trial Date 2"
                      name="act2_try_date2"
                      onChange={handleInputChange}
                      value={studentData.act2_try_date2}
                    />
                    <Input
                      type="text"
                      placeholder="Trial 2 Id"
                      name="act2_try2_id"
                      onChange={handleInputChange}
                      value={studentData.act2_try2_id}
                      required={false}
                    />
                    <Input
                      type="number"
                      placeholder="ACT subject 3 score"
                      name="act2_score3"
                      required={false}
                      onChange={handleInputChange}
                      value={studentData.act2_score3}
                    />
                    <div className="m-2 flex items-center justify-center">
                      <label htmlFor="subject3" className="flex-auto">
                        ACT subject 3:
                      </label>
                      <select
                        className="flex-initial p-2 ml-1 border border-white/10 rounded-xl bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                        onChange={handleInputChange}
                        name="subject3"
                        value={studentData.subject3}
                      >
                        {ACT_SUBJECTS.map((subject, i) => (
                          <option value={subject.value} key={i}>
                            {subject.text}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Input
                      placeholder="Trial Date 3"
                      type="date"
                      required={false}
                      name="act2_try_date3"
                      onChange={handleInputChange}
                      value={studentData.act2_try_date3}
                    />
                    <Input
                      type="text"
                      placeholder="Trial 3 Id"
                      name="act2_try3_id"
                      onChange={handleInputChange}
                      value={studentData.act2_try3_id}
                      required={false}
                    />
                    <Input
                      type="number"
                      placeholder="Number of Copies "
                      name="act2_copy_number"
                      onChange={handleInputChange}
                      value={studentData.act2_copy_number}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-row-reverse justify-between pt-4">
            <Button
              color="bg-indigo-600 hover:bg-indigo-500 disabled:bg-white/10 disabled:text-slate-500"
              disabled={loading}
              text={
                !loading ? (
                  <>{pathname === "new" ? "Edit and Forward" : "Edit"}</>
                ) : (
                  <Loading />
                )
              }
            />
          </div>
        </form>
      </div>
    </div>
  );
}

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}
